var $=jQuery;


$(document).ready(function () {
  
    $('.header__inline-menu .mega-menu__content ul.mega-menu__list>li>a.has_sub').click(function (e) { 
      e.preventDefault();
      $('.header__inline-menu .mega-menu__content ul.mega-menu__list>li>a.has_sub').removeClass('showing');
      $(this).addClass('showing');
    });
    
    $(".hotspot-point").click(function () {
        $(".hotspot-point").removeClass('active');
        $(this).addClass('active');
        let productHandle = $(this).data("product");
        let infoBox = $(this).next(".hotspot-product-info");
      
        if (productHandle) {
            $.getJSON(`/products/${productHandle}.json`, function (data) {
                let product = data.product;
                let vendor = product.vendor;
                let productHtml = `
                  <a href="/products/${product.handle}" class="hotspot-image-link">
                        <img src="${product.image.src}" class="hotspot-product-img">
                  </a>
                  <a href="/products/${product.handle}" class="hotspot-title-link">
                      <p class="product-vendor">${vendor}</p>
                      <p class="title-h3">${product.title}</p>
                      <p>
                        ${product.variants[0].price} €
                      </p>
                  </a>
                `;
                infoBox.find(".hotspot-product-content").html(productHtml);
                $(".hotspot-product-info").hide(); // Hide all other boxes
                infoBox.fadeIn(); // Show current box
            });
        }

        event.stopPropagation(); // Prevent closing when clicking on the hotspot
    });
   $(document).click(function (event) {
        if (!$(event.target).closest(".hotspot-product-info, .hotspot-point").length) {
            $(".hotspot-product-info").fadeOut();
        }
    });
  //End Point Section
    $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
    });
    $('.notification-close').click(function (e) { 
        e.preventDefault();
        $('.notification-bar').slideUp();
    });
    function setEqualHeight() {
      var maxHeight = 0;
      $('.collection .card__heading').css('height', 'auto');
  
      $('.collection .card__heading').each(function() {
          var currentHeight = $(this).outerHeight();
          if (currentHeight > maxHeight) {
              maxHeight = currentHeight;
          }
      });
  
      $('.collection .card__heading').each(function() {
          $(this).css('height', maxHeight + 'px');
      });
    }

    $(document).ready(function() {
        setEqualHeight();
    });
    
    $(window).on('resize', function() {
        setEqualHeight();
    });
       var $gallery = $('.product-single__gallery');
    var itemCount = $gallery.find('.product-single__gallery-item').length;

    if (itemCount > 1) {  
      $gallery.flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
      });
    }

    // $('.product-single__gallery').flickity({
    //     imagesLoaded: true,
    //     groupCells: false,
    //     dragThreshold: 5,
    //     cellAlign: 'center',
    //     wrapAround: true,
    //     prevNextButtons: true,
    //     percentPosition: true, 
    //     pageDots: false,
    //     rightToLeft: false,
    //     autoPlay: false,
    //     sync: '.product-single__thumbnails'
    // }); 
  
    $('.product-single__gallery').on('change.flickity', function(event, index) {
        var $thumbnails = $('.product-single__thumbnails li');
        $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
        $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
    });
    $('.product-single__thumbnails li').first().addClass('active');
  
    // Thumbnail click event to change the gallery image
    $('.product-single__thumbnails li').on('click', function() {
        var index = $(this).index();
        $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
    });
    ///// Tab Faq
    $(document).on('click','.acctab_title', function(e){
        if($(window).width() >= 768){
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }else{
        $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        }
        else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
    //Slider collection list
    $('.multi_slider .multicolumn-list').flickity({ 
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: true,
        rightToLeft: false,
        autoPlay: false,
    });
    //End Slider collection list
    /*** LOAD MORE **/
  $(document).on('click', '[data-pagination-link]', function(e) {
    e.preventDefault();
    const $button = $(this);
    const nextUrl = $button.attr('href');

    $button.text("Laden...");
    $button.prop('disabled', true);

    $.get(nextUrl, function(response) {
        const $tempDiv = $('<div>').html(response);
        const newProductsHtml = $tempDiv.find('#product-grid').html();
        const $newButton = $tempDiv.find('[data-pagination-link]');
        
        $('ul#product-grid').append(newProductsHtml);
        $button.closest('.show_more_btn').remove(); // remove old button wrapper

        if ($newButton.length) {
            $('ul#product-grid').after($newButton.closest('.show_more_btn')); // add new button wrapper
        }
    }).fail(function() {
        console.error('Error loading more products.');
        $button.text("Try again");
        $button.prop('disabled', false);
    });
});

/** LOAD MORE****/

  function slider_mobile() {
    if($(window).width() <= 949){
      $(".related-grid").flickity({
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: false,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
      $(".announcement-bar .grid").flickity({
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: false,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
    }
  }
  $(document).ready(slider_mobile);
  $(window).on('resize', function() {
    slider_mobile();
  });
  slider_mobile();
});

$(document).ready(function () {
  const checkboxes = $('.facets_price_custom input[type="checkbox"]'); // Select all checkboxes
  const minInput = $('input#Filter-Preis-GTE'); // Input for minimum value
  const maxInput = $('input#Filter-Preis-LTE'); // Input for maximum value

  checkboxes.on('change', function () {
    if ($(this).is(':checked')) {
      // Uncheck all other checkboxes
      checkboxes.not(this).prop('checked', false);

      // Extract values from the selected checkbox
      const values = $(this).val().split(' - '); // Split the value into [min, max]
      const minValue = values[0].trim(); // Get the minimum value
      const maxValue = values[1].trim(); // Get the maximum value

      // Assign values to the inputs
      minInput.val(minValue).trigger('input');
      maxInput.val(maxValue).trigger('input');
    } else {
      // Reset inputs when the checkbox is unchecked
      minInput.val('').trigger('input');
      maxInput.val('').trigger('input');
    }
  });
  $(document).on('change', '.select__select', function () {
  
    var $select = $(this);
    var $productItem = $select.closest('.pdp_detail');
    // var newImage = $(this).find('option:selected').attr('data-image'); 
    // $productItem.find('.pdp-img-crspdp').attr('src', newImage);
    var selectedOptions = [];

    $productItem.find('.select__select').each(function () {
      selectedOptions.push($(this).val());
    });

    var variants = JSON.parse($productItem.attr('data-variants'));

    var matchedVariant = variants.find(function (variant) {
      return variant.options.every(function (opt, index) {
        return opt === selectedOptions[index];
      });
    });

    if (matchedVariant) {
      var $priceContainer = $productItem.find('.price-custom');
      var priceHtml = '';

      if (matchedVariant.compare_at_price > matchedVariant.price) {
      
        priceHtml += '<span class="sale-price">' + formatMoney(matchedVariant.price) + '</span>';
        priceHtml += '<span class="original-price">' + formatMoney(matchedVariant.compare_at_price) + '</span>';
        priceHtml += '<span class="du-sparst">Du sparst ' + formatMoney(matchedVariant.compare_at_price - matchedVariant.price) + '</span>';
      } else {
        priceHtml += '<span class="regular-price">' + formatMoney(matchedVariant.price) + '</span>';
      }
      // priceHtml = priceHtml.replace("€", ' €')
      $priceContainer.html(priceHtml);

      $productItem.find('.product-variant-id').val(matchedVariant.id);
      var $btn = $productItem.find('button[type="submit"]');
      if (matchedVariant.available) {
        $btn.prop('disabled', false);
      } else {
        $btn.prop('disabled', true);
      }
    }
  });
});

/**** CUSTOM  PRICE ***/

function formatMoney(cents) {
    // return (cents / 100).toFixed(2).toLocaleString('de-DE') + '€\u00A0';
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }